/* PagingDeviceConfigurationSnapshotFeed.js */

"use strict";
const PagingFeed = require("../../../../lib/PagingFeed");

class PagingDeviceConfigurationSnapshotFeed extends PagingFeed {
    _getFeed() {
        return this._relatedEntityDef.startDeviceConfigurationsFeed(this._activeOrgId, this._filter, this._entityFields, this._sort, {
            skip: 0,
            limit: this._pageSize * 2
        });
        // return this._EntityDef.startRelatedDeviceConfigurationsFeed(
        //     this._filter,
        //     this._entityFields,
        //     this._sort,
        //     { skip: 0, limit: this._pageSize * 2 }
        // );
    }

    _getFeedIdsForSelection(tenantId, selection) {
        return this._EntityDef.loadDeviceIdsForSelection(tenantId, selection);
    }

    getDeviceEntitiesById(ids) {
        return this.getEntitiesById(ids);
    }

    getDeviceEntitiesNameById(ids) {
        return this.getEntitiesNameById(ids);
    }

    getDeviceEntityById(id) {
        return this.getEntityById(id);
    }
}

module.exports = PagingDeviceConfigurationSnapshotFeed;
